import { useEffect } from "react";
import { View } from "react-native";
import { useNavigate } from "react-router-dom";
import { SESSIONSTORAGE } from "../value/staticValues";
import { PAGE_URL } from "../value/Url";
import MainPage from "./MainPage";

export default function MainPageContainer() {
    const user_id = sessionStorage.getItem(SESSIONSTORAGE.USER_EMAIL);
    const navigate = useNavigate();

    useEffect(() => {
        if(!user_id) {
            navigate(PAGE_URL.LOGIN);
        }
    }, [user_id])

    
    return (
        <View style={{width:window.outerWidth, backgroundColor:"#f3f7ff"}}>
            <MainPage/>
        </View>
    )
}